<template>
    <div class="footer">
        <div class="main">
            <div class="info">
                <div>@山东环境科学学会&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;版权所有[{{ footerInfo.beian }}]</div>
                <div>电话：{{ footerInfo.mobile }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;网址:{{ footerInfo.weburl }}</div>
                <div>地址：{{ footerInfo.address }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;邮箱：{{ footerInfo.email }}</div>
            </div>
            <div class="qrcode_box">
                <img class="qrcode" :src="footerInfo.official" />
                <div class="code_font">公众号</div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, getCurrentInstance, onMounted, reactive } from 'vue'
const api = getCurrentInstance().proxy.$api;
//底部栏信息
const footerInfo = ref("")
const getFooterInfo = async () => {
    const res = await api.post('/index/bottom', { article_id: 1 })
    footerInfo.value = res.data || []
}
onMounted(() => {
    getFooterInfo()
})
</script>
<style scoped lang="scss">
.footer {
    box-sizing: border-box;
    width: 100%;
    background: #EFF3F6;
    display: flex;
    align-items: center;

    .main {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        width: 94%;
        height: 120px;
        padding: 20px 0;
        box-sizing: border-box;


        .info {
            line-height: 25px;
            text-align: left;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
        }

        .qrcode_box {
            display: flex;
            flex-direction: column;
            align-items: center;

            .qrcode {
                width: 52px;
                height: 52px;
                background: #fff;
            }

            .code_font {
                margin-top: 10px;
                font-weight: 400;
                font-size: 12px;
                color: #000000;
            }
        }
    }

}
</style>